const sectionTitleStyle = {
  fontFamily: "var(--font-serif)",
  fontStyle: "italic",
  fontSize: "18px",
  color: "var(--color-ink)",
  margin: 0,
};

const bodyStyle = { fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.85)", margin: 0 };
const listStyle = { display: "flex", flexDirection: "column", gap: "8px", margin: 0, paddingLeft: "20px" };
const subheadStyle = { fontSize: "15px", fontWeight: 600, color: "var(--color-ink)", margin: 0 };
const metaStyle = { fontSize: "13px", fontStyle: "italic", lineHeight: 1.6, color: "rgba(10,9,7,0.6)", margin: 0 };

function Section({ roman, title, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <p style={sectionTitleStyle}>
        {roman}. {title}
      </p>
      {children}
    </div>
  );
}

function Sub({ title, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      {title && <p style={subheadStyle}>{title}</p>}
      {children}
    </div>
  );
}

const ANHAENGE = [
  { file: "/assets/ueber-uns/documents/anhang-a-verhaltenskodex-mitarbeitende.pdf", titleDe: "Anhang A: Verhaltenskodex für Mitarbeitende und Ehrenamtliche", titleEn: "Appendix A: Code of Conduct for Staff and Volunteers (German)" },
  { file: "/assets/ueber-uns/documents/anhang-b-verhaltenskodex-veranstaltungen.pdf", titleDe: "Anhang B: Verhaltenskodex für Veranstaltungen", titleEn: "Appendix B: Code of Conduct for Events (German)" },
  { file: "/assets/ueber-uns/documents/anhang-c-selbstverpflichtungserklaerung.pdf", titleDe: "Anhang C: Selbstverpflichtungserklärung", titleEn: "Appendix C: Self-Commitment Declaration (German)" },
  { file: "/assets/ueber-uns/documents/anhang-d-checkliste-jugendevents.pdf", titleDe: "Anhang D: Checkliste für Jugendevents", titleEn: "Appendix D: Youth Event Checklist (German)" },
  { file: "/assets/ueber-uns/documents/anhang-e-kontakte-beratungsstellen.pdf", titleDe: "Anhang E: Kontakte und externe Beratungsstellen", titleEn: "Appendix E: Contacts and External Counseling Services (German)" },
];

export function JugendschutzAnhaenge({ lang }) {
  return (
    <div className="tl-card-light" style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "32px 36px" }}>
      <p style={{ ...subheadStyle, fontSize: "16px" }}>{lang === "de" ? "Anhänge zum Download" : "Appendices (download)"}</p>
      <ul style={{ display: "flex", flexDirection: "column", gap: "14px", margin: 0, padding: 0, listStyle: "none" }}>
        {ANHAENGE.map((a) => (
          <li key={a.file}>
            <a href={a.file} target="_blank" rel="noopener noreferrer" style={{ fontSize: "15px" }}>
              {lang === "de" ? a.titleDe : a.titleEn} (PDF)
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

/**
 * Real policy content, transcribed from konzepte/Jugendschutzkonzept_TalesLegends.docx
 * (Stand August 2026) — adapted from the "Dachverbandliches Schutzkonzept im
 * Amateurtheater" (LABW/BDAT). The five Anhänge (appendices) exist as
 * separate signed/printable PDFs already, so they're linked as downloads
 * (see JugendschutzAnhaenge above) rather than re-transcribed inline here.
 */
export function JugendschutzkonzeptDe() {
  return (
    <div className="tl-card-light" style={{ display: "flex", flexDirection: "column", gap: "32px", padding: "44px 40px" }}>
      <p style={metaStyle}>
        Stand: August 2026 — Verantwortlich: Geschäftsführung Tales&amp;Legends gUG. Dieses Konzept basiert auf dem
        Dachverbandlichen Schutzkonzept im Amateurtheater (LABW/BDAT, Stand 05/2026) und wurde für den spezifischen
        Kontext von Tales&amp;Legends Jugendevents adaptiert. Es gilt ab August 2026 und wird mindestens jährlich
        überprüft.
      </p>

      <Section roman="I" title="Einleitung und Selbstverständnis">
        <p style={bodyStyle}>
          Tales&amp;Legends gUG ist eine gemeinnützige Unternehmergesellschaft, die Jugendevents im Bereich
          Pen-&amp;-Paper-Rollenspiele, LARP (Live-Action-Rollenspiel), Tabletop-Spiele und verwandte kreative
          Formate veranstaltet. Diese Veranstaltungen schaffen Räume für kreative Entfaltung, soziales Lernen und
          gemeinschaftliches Erleben – und sie bringen Kinder, Jugendliche und Erwachsene in intensive gemeinsame
          Situationen.
        </p>
        <p style={bodyStyle}>
          Genau diese Intensität birgt neben großen Chancen auch besondere Verantwortung. Tales&amp;Legends gUG
          nimmt diese Verantwortung ernst: Wir wollen, dass alle Teilnehmenden – insbesondere Kinder und
          Jugendliche – unsere Veranstaltungen als sichere, respektvolle und bereichernde Orte erleben.
        </p>
        <p style={bodyStyle}>
          Dieses Jugendschutzkonzept beschreibt, wie wir dieser Verantwortung gerecht werden. Es legt Grundsätze,
          Strukturen, Verhaltensregeln und Handlungsabläufe fest, die dazu beitragen sollen, Grenzverletzungen zu
          verhindern, frühzeitig zu erkennen und – falls nötig – angemessen zu reagieren.
        </p>
        <Sub title="Geltungsbereich">
          <p style={bodyStyle}>
            Dieses Konzept gilt für alle Tales&amp;Legends Jugendevents, Workshops und Veranstaltungen, an denen
            Minderjährige (unter 18 Jahren) teilnehmen. Es ist verbindlich für alle hauptamtlichen und
            ehrenamtlichen Mitarbeitenden sowie für alle externen Spielleiter:innen und Honorarkräfte.
          </p>
        </Sub>
      </Section>

      <Section roman="II" title="Leitbild und Werte">
        <Sub title="Sicherheit und Würde">
          <p style={bodyStyle}>
            Jede Person, die an unseren Veranstaltungen teilnimmt, hat ein Recht auf körperliche und seelische
            Unversehrtheit. Wir schaffen Räume, in denen Grenzen – auch im Spiel – respektiert werden. Das fiktive
            Setting entbindet niemanden von der Pflicht, reale Grenzen anderer zu achten.
          </p>
        </Sub>
        <Sub title="Respekt und Wertschätzung">
          <p style={bodyStyle}>
            Alle Teilnehmenden werden unabhängig von Alter, Geschlecht, Herkunft, Erfahrungsstand oder körperlichen
            Voraussetzungen gleichwertig behandelt. Hierarchien – etwa zwischen Spielleitung und Teilnehmenden –
            werden bewusst und verantwortungsvoll gestaltet.
          </p>
        </Sub>
        <Sub title="Transparenz und Partizipation">
          <p style={bodyStyle}>
            Regeln und Abläufe werden offen kommuniziert. Jugendliche werden in die Gestaltung von Veranstaltungen
            einbezogen. Rückmeldungen und Beschwerden werden ernst genommen.
          </p>
        </Sub>
        <Sub title="Verantwortungsvolles Handeln">
          <p style={bodyStyle}>
            Alle Mitarbeitenden kennen ihre Verantwortung und handeln im Sinne des Kinderschutzes. Im Zweifel steht
            das Wohl der Kinder und Jugendlichen über anderen Interessen.
          </p>
        </Sub>
      </Section>

      <Section roman="III" title="Grundlagen und Begriffe">
        <Sub title="Formen von Grenzverletzung und Gewalt">
          <ul style={listStyle}>
            <li style={bodyStyle}>
              <strong>Grenzverletzendes Verhalten:</strong> Verhaltensweisen, bei denen persönliche Grenzen anderer
              überschritten werden, ohne dass dies der handelnden Person bewusst sein muss.
            </li>
            <li style={bodyStyle}>
              <strong>Übergriffiges Verhalten:</strong> Grenzen werden bewusst überschritten, oft unter Ausnutzung
              von Machtasymmetrien.
            </li>
            <li style={bodyStyle}>
              <strong>Psychische Gewalt:</strong> Erniedrigung, emotionale Manipulation, Mobbing – auch unter dem
              Deckmantel von Spielhandlungen.
            </li>
            <li style={bodyStyle}>
              <strong>Physische Gewalt:</strong> Körperliche Schädigung oder unerwünschter Körperkontakt.
            </li>
            <li style={bodyStyle}>
              <strong>Sexualisierte Gewalt:</strong> Verletzung der sexuellen Selbstbestimmung, auch verbale
              Übergriffe, unerwünschte Berührungen oder sexuelle Inhalte in Szenen ohne Einwilligung.
            </li>
          </ul>
        </Sub>
        <Sub title="Besonderheiten im Rollenspiel-Kontext">
          <p style={bodyStyle}>
            Kreative Formate wie LARP und Pen &amp; Paper schaffen durch ihren fiktionalen Rahmen besondere
            Risiken: Die Grenze zwischen Figur und Person kann verschwimmen, Grenzverletzungen können als
            „Spielhandlung" getarnt werden, und intensive Szenen können Trigger auslösen.
          </p>
          <p style={{ ...bodyStyle, fontWeight: 600 }}>
            Grundsatz: Das Spiel endet, wenn eine reale Person Schaden nimmt. Kein fiktiver Kontext rechtfertigt eine
            reale Grenzüberschreitung. Sicherheits-Signale (z.&nbsp;B. „Stop", „Brake") sind immer bindend und werden
            sofort respektiert.
          </p>
        </Sub>
      </Section>

      <Section roman="IV" title="Gesetzliche Grundlagen">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            <strong>§ 8a SGB VIII</strong> (Schutzauftrag bei Kindeswohlgefährdung): Bei Hinweisen auf eine
            Kindeswohlgefährdung ist das Jugendamt einzubeziehen.
          </li>
          <li style={bodyStyle}>
            <strong>§ 72a SGB VIII</strong> (Erweitertes Führungszeugnis): Personen mit regelmäßigem Kontakt zu
            Minderjährigen müssen ein erweitertes Führungszeugnis vorlegen.
          </li>
          <li style={bodyStyle}>
            <strong>Jugendschutzgesetz (JuSchG):</strong> Regelt Veranstaltungszeiten, zulässige Inhalte und
            Aufsichtspflichten.
          </li>
          <li style={bodyStyle}>
            <strong>DSGVO / BDSG:</strong> Personenbezogene Daten werden datenschutzkonform verarbeitet; Fotos und
            Videos erfordern ausdrückliche Einwilligung (bei Minderjährigen von den Erziehungsberechtigten).
          </li>
        </ul>
        <p style={bodyStyle}>
          Tales&amp;Legends gUG ist verpflichtet, mit dem zuständigen Jugendamt eine Vereinbarung nach § 72a SGB
          VIII zu schließen, die die Vorlage erweiterter Führungszeugnisse für alle relevanten Mitarbeitenden und
          Ehrenamtlichen regelt.
        </p>
      </Section>

      <Section roman="V" title="Risiko- und Potenzialanalyse">
        <Sub title="Spezifische Risikosituationen">
          <ul style={listStyle}>
            <li style={bodyStyle}>Spielszenen mit emotionaler oder körperlicher Intensität</li>
            <li style={bodyStyle}>Mehrtägige Events mit Übernachtung</li>
            <li style={bodyStyle}>Einzelbetreuung und Einzelgespräche</li>
            <li style={bodyStyle}>Digitale Vorkommunikation (Discord, WhatsApp)</li>
            <li style={bodyStyle}>Altersgemischte Gruppen</li>
            <li style={bodyStyle}>Rollenspiel-spezifische Grenzverschiebung</li>
          </ul>
        </Sub>
        <Sub title="Vorhandene Schutzfaktoren">
          <ul style={listStyle}>
            <li style={bodyStyle}>Bewährte Safety-Tools (z.&nbsp;B. X-Card, Brake-System)</li>
            <li style={bodyStyle}>Erfahrenes Team mit pädagogischer Sensibilität</li>
            <li style={bodyStyle}>Kleine, überschaubare Gruppengrößen</li>
            <li style={bodyStyle}>Offene Kommunikationskultur</li>
          </ul>
        </Sub>
      </Section>

      <Section roman="VI" title="Prävention und Schutzmaßnahmen">
        <Sub title="Strukturelle Maßnahmen">
          <ul style={listStyle}>
            <li style={bodyStyle}>
              Für jedes Event wird eine <strong>Jugendschutzbeauftragte Person</strong> benannt.
            </li>
            <li style={bodyStyle}>
              Bei Jugendevents sind mindestens zwei erwachsene Mitarbeitende anwesend; bei Übernachtungen ein
              ausgewogenes Verhältnis zwischen weiblichen und männlichen Bezugspersonen.
            </li>
            <li style={bodyStyle}>Empfohlener Betreuungsschlüssel: max. 1:8 (unter 14 Jahren: 1:6).</li>
          </ul>
        </Sub>
        <Sub title="Erweitertes Führungszeugnis">
          <p style={bodyStyle}>
            Alle Mitarbeitenden und Ehrenamtlichen, die regelmäßig und direkt mit Minderjährigen arbeiten, müssen
            vor Aufnahme ihrer Tätigkeit ein erweitertes Führungszeugnis nach § 72a SGB VIII vorlegen – nicht älter
            als 3 Monate, alle 5 Jahre erneuert. Das Zeugnis selbst wird nicht aufbewahrt (Datenschutz), nur Datum
            der Einsichtnahme und zuständige Person werden dokumentiert.
          </p>
        </Sub>
        <Sub title="Safety-Tools im Spiel">
          <ul style={listStyle}>
            <li style={bodyStyle}>
              <strong>X-Card:</strong> jederzeit und ohne Begründung eine Szene stoppen – sofort und kommentarlos
              respektiert.
            </li>
            <li style={bodyStyle}>
              <strong>Brake-System:</strong> „Brake" verändert Intensität/Richtung einer Szene, „Full stop" beendet
              sie vollständig.
            </li>
            <li style={bodyStyle}>
              <strong>Lines &amp; Veils:</strong> vor jedem Event verbindlich vereinbarte Themen, die nicht (Lines)
              oder nur angedeutet (Veils) vorkommen dürfen.
            </li>
            <li style={bodyStyle}>
              <strong>Debrief:</strong> nach intensiven Szenen, trennt zwischen Figur und Person (De-Roling).
            </li>
          </ul>
        </Sub>
        <Sub title="Aufklärung der Eltern">
          <p style={bodyStyle}>
            Erziehungsberechtigte erhalten vor der Anmeldung vollständige Informationen zu Programm, anwesenden
            Betreuer:innen, dem Jugendschutzkonzept und Safety-Tools. Bei Minderjährigen unter 16 Jahren ist die
            schriftliche Einverständniserklärung der Erziehungsberechtigten verpflichtend.
          </p>
        </Sub>
      </Section>

      <Section roman="VII" title="Ansprechpersonen und Beschwerdewege">
        <p style={bodyStyle}>
          Für jedes Jugendevent wird eine Jugendschutzbeauftragte Person (JSB) benannt, die allen Teilnehmenden –
          und bei Mehrtagesevents auch den Erziehungsberechtigten – namentlich bekanntgemacht wird. Sie ist erste
          Anlaufstelle für Fragen, Unsicherheiten und Beschwerden, nimmt Hinweise auf Grenzverletzungen entgegen und
          koordiniert die weiteren Schritte.
        </p>
        <p style={bodyStyle}>
          Beschwerden können direkt persönlich, schriftlich, anonym oder durch Dritte geäußert werden. Sie werden
          vertraulich behandelt; niemand wird für das Äußern einer Beschwerde benachteiligt.
        </p>
        <p style={bodyStyle}>
          Externe Beratungsstellen (aktuelle Kontakte siehe Anhang E) umfassen das zuständige Jugendamt,
          Kinderschutz-Beratungsstellen, die Nummer gegen Kummer (0800&nbsp;111&nbsp;0&nbsp;333, kostenfrei) sowie im
          Notfall Polizei (110) und Notruf (112).
        </p>
      </Section>

      <Section roman="VIII" title="Handlungsleitfäden bei Vorfällen">
        <p style={bodyStyle}>
          Bei allen Vorfällen gilt: Ruhe bewahren, die betroffene Person ernst nehmen, keine voreiligen Schlüsse
          ziehen, keine Konfrontation mit der gemeldeten Person ohne Rücksprache, keine Einzelintervention – im Team
          handeln, im Zweifel externe Fachstellen einbeziehen.
        </p>
        <Sub title="Verdacht auf sexualisierte Gewalt oder Kindeswohlgefährdung">
          <p style={bodyStyle}>
            Betroffene Person stabilisieren, nicht alleine entscheiden (Rücksprache mit JSB und Geschäftsführung),
            eine insoweit erfahrene Fachkraft nach § 8a SGB VIII einbeziehen, alles dokumentieren, Erziehungsberechtigte
            informieren (außer wenn dies das Kind gefährden würde), bei konkretem Verdacht das Jugendamt einschalten.
            Bei akuter Gefahr sofort 110 oder 112.
          </p>
        </Sub>
      </Section>

      <Section roman="IX" title="Digitaler Schutz und Mediennutzung">
        <p style={bodyStyle}>
          Kommunikation mit Minderjährigen erfolgt über offizielle Gruppenkanäle, nicht private Einzelchats.
          Mitarbeitende nutzen ausschließlich offizielle Accounts. Fotos und Videos erfordern vorherige schriftliche
          Einwilligung – bei Minderjährigen von den Erziehungsberechtigten – und dürfen nur nach erneuter Rückfrage
          veröffentlicht werden; Teilnehmende können jederzeit die Löschung verlangen.
        </p>
      </Section>

      <Section roman="X" title="Qualitätssicherung und Weiterentwicklung">
        <p style={bodyStyle}>
          Das Konzept wird mindestens einmal jährlich von der Geschäftsführung gemeinsam mit den Mitarbeitenden
          überprüft und bei Bedarf aktualisiert. Alle Mitarbeitenden werden regelmäßig zu Kinderschutz und
          Prävention geschult; neue Mitarbeitende vor ihrem ersten Einsatz eingeführt. Rückmeldungen von
          Teilnehmenden und Erziehungsberechtigten fließen aktiv in die Weiterentwicklung ein.
        </p>
      </Section>

      <Section roman="—" title="Interne Ansprechperson">
        <p style={bodyStyle}>
          Geschäftsführung: Nils —{" "}
          <a href="mailto:nils@talesandlegends.org">nils@talesandlegends.org</a>. Die event-spezifische
          Jugendschutzbeauftragte Person wird vor jeder Veranstaltung benannt.
        </p>
      </Section>
    </div>
  );
}

export function JugendschutzkonzeptEn() {
  return (
    <div className="tl-card-light" style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "44px 40px" }}>
      <p style={bodyStyle}>
        Tales&amp;Legends gUG has adopted a formal youth-safeguarding concept (Jugendschutzkonzept, effective August
        2026, based on the German amateur-theater umbrella association's safeguarding framework). Because it cites
        specific German child-protection statutes (SGB&nbsp;VIII, JuSchG) and defines procedures in precise German
        legal and safety terminology, we're publishing it in German only for now, rather than risk an inaccurate
        translation of safety-critical wording — see the German version of this page (use the language switcher
        above) for the full text.
      </p>
      <p style={{ ...bodyStyle, fontWeight: 600 }}>In short, the concept covers:</p>
      <ul style={listStyle}>
        <li style={bodyStyle}>A named youth-safeguarding contact person (Jugendschutzbeauftragte) for every youth event, introduced to participants and parents by name</li>
        <li style={bodyStyle}>Extended background checks (erweitertes Führungszeugnis) required for all staff and volunteers with regular contact with minors, per § 72a SGB VIII</li>
        <li style={bodyStyle}>In-game safety tools (X-Card, a Brake system, and Lines &amp; Veils agreed before every event) that any participant can invoke at any time, no explanation required</li>
        <li style={bodyStyle}>A minimum staffing ratio (at most 1:8, or 1:6 for under-14s) and at least two adult staff present at every youth event</li>
        <li style={bodyStyle}>Written parental consent required for participants under 16, with full information about the program, staff, and safety concept shared beforehand</li>
        <li style={bodyStyle}>Clear, confidential reporting channels (in person, in writing, or anonymously) and defined escalation steps, including mandatory involvement of an experienced child-protection specialist and the local Jugendamt where required by § 8a SGB VIII</li>
        <li style={bodyStyle}>Rules for digital communication and photo/video consent involving minors</li>
        <li style={bodyStyle}>An annual review cycle</li>
      </ul>
      <p style={bodyStyle}>
        Questions about any of this are welcome at{" "}
        <a href="mailto:nils@talesandlegends.org">nils@talesandlegends.org</a>.
      </p>
    </div>
  );
}
